// removed by extract-text-webpack-plugin
module.exports = {"container":"category-cell__container___3cag8","tag":"category-cell__tag___3NELA","close":"category-cell__close___gENfU","warn":"category-cell__warn___assXT","icon":"category-cell__icon___1_Qxh","tooltip-top":"category-cell__tooltip-top___1r96W","tooltip-bottom":"category-cell__tooltip-bottom___24tth"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/category-cell.scss
// module id = 511
// module chunks = 0